// Modules
import React from "react";

const DeskIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<g>
					<path d="M440,188h-8v-64c-0.026-22.08-17.92-39.974-40-40H120c-22.08,0.026-39.974,17.92-40,40v64h-8
			c-39.744,0.048-71.952,32.256-72,72v112h16v56h40v-56h400v56h40v-56h16V260C511.952,220.256,479.744,188.048,440,188z M96,124
			c0-13.255,10.745-24,24-24h272c13.255,0,24,10.745,24,24v64h-24v-32c0-13.255-10.745-24-24-24h-72c-13.255,0-24,10.745-24,24v32
			h-32v-32c0-13.255-10.745-24-24-24h-72c-13.255,0-24,10.745-24,24v32H96V124z M376,156v32h-88v-32c0-4.418,3.582-8,8-8h72
			C372.418,148,376,151.582,376,156z M224,156v32h-88v-32c0-4.418,3.582-8,8-8h72C220.418,148,224,151.582,224,156z M40,412h-8v-40
			h8V412z M480,412h-8v-40h8V412z M496,356H16v-40h480V356z M496,300H16v-40c0.035-30.913,25.087-55.965,56-56h368
			c30.913,0.035,55.965,25.087,56,56V300z"/>
				</g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
		</svg>
	);
};

export default DeskIcon;
